var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopNavigationProfilePictureIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2779 16.5757V15.048C15.2779 14.2376 14.956 13.4604 14.3829 12.8873C13.8099 12.3143 13.0327 11.9924 12.2223 11.9924H6.11122C5.30084 11.9924 4.52364 12.3143 3.95062 12.8873C3.37759 13.4604 3.05566 14.2376 3.05566 15.048V16.5757M12.2223 5.88128C12.2223 7.56882 10.8543 8.93684 9.16677 8.93684C7.47924 8.93684 6.11122 7.56882 6.11122 5.88128C6.11122 4.19375 7.47924 2.82573 9.16677 2.82573C10.8543 2.82573 12.2223 4.19375 12.2223 5.88128Z",
    stroke: "white",
    strokeWidth: 1.81424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopNavigationProfilePictureIcon);
export default __webpack_public_path__ + "static/media/top-navigation-profile-picture-icon.15f84638f033c83a3a5faabb6f05cb1f.svg";
export { ForwardRef as ReactComponent };